var map = {
	"./cake.webp": 2375,
	"./correct-ico.webp": 2376,
	"./crown-blue.webp": 2377,
	"./crown.webp": 2378,
	"./pocket.webp": 2379,
	"./present.webp": 2380,
	"./relegation.webp": 2381,
	"./t-deposit.webp": 2382,
	"./t-turnover.webp": 2383,
	"./vip-1.webp": 2384,
	"./vip-2.webp": 2385,
	"./vip-3.webp": 2386,
	"./vip-4.webp": 2387,
	"./vip-5.webp": 2388,
	"./vip-badge.webp": 2389,
	"./vip-bg.webp": 2390,
	"./vip-bonus-bg.webp": 2391,
	"./vip1.webp": 2392,
	"./vip2.webp": 2393,
	"./vip3.webp": 2394,
	"./vip4.webp": 2395,
	"./vip5.webp": 2396,
	"./vip6.webp": 2397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;